

export const truncate = (s: string, n: number, replaceWith?: string) => !!s && (s.length > n) ? s.substr(0, n - 1) + (replaceWith || '&hellip;') : s;

export const capitalizeFirstLetter = (s: string) => {
    if (!s) return s;
    if (s.length == 1) return s.toUpperCase();
    return s.charAt(0).toUpperCase() + s.slice(1);
}